import { connect } from 'react-redux';
import QuickBidPartPhotos from 'components/bids/QuickBidPartPhotos';
import {
  clearAuctionPartImages,
  clearDeleteAuctionPartImages,
  clearUploadAuctionPartImages,
  fetchAuctionPartImages,
  deleteAuctionPartImages,
  uploadAuctionPartImages,
} from 'data/auctions/Auctions.actions';
import { getStateExtractor } from 'lib/ReduxHelper';

const mapStateToProps = getStateExtractor(
  'app.userParty',
  'app.lookups.partTypes',
  'auctions.uploadAuctionPartImages->uploaded',
  'auctions.uploadAuctionPartImagesError->uploadError',
  'auctions.uploadingAuctionPartImages->uploading',
  'remote#auctions.deleteAuctionPartImages',
  'auctions.auctionPartImages->images',
  'auctions.auctionPartImagesError->imagesError',
  'auctions.fetchingAuctionPartImages->imagesPending'
);

const mapDispatchToProps = dispatch => ({
  onClear: () => {
    dispatch(clearAuctionPartImages());
    dispatch(clearDeleteAuctionPartImages());
    dispatch(clearUploadAuctionPartImages());
  },
  onDelete: id => dispatch(deleteAuctionPartImages([id])),
  onFetch: (auctionId, merchantId) =>
    dispatch(fetchAuctionPartImages(auctionId, merchantId)),
  onUpload: (auctionId, files) =>
    dispatch(uploadAuctionPartImages(auctionId, files)),
});

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { ID: merchantId } = stateProps.userParty;
  const { auctionId } = ownProps;

  const { onUpload: _onUpload, onFetch: _onFetch } = dispatchProps;

  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    merchantId,
    onFetch: () => _onFetch(auctionId, merchantId),
    onUpload: files => _onUpload(auctionId, files),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(QuickBidPartPhotos);
